exports.linkResolver = (doc) => {
  switch (doc.type) {
    case "blog_post":
      return `/blog/${doc.uid}`;

    case "symposium":
      return `/${doc.uid}`;

    case "new_qualify_form_page":
      return `/${doc.uid}`;

    case "captive_vs_microcaptive_page":
      return `/${doc.uid}`;

    case "new_831b_plan_page":
      return `/${doc.uid}`;

    case "product_guide_page":
      return `/${doc.uid}`;

    default:
      if (!doc.uid) return "/";
      return doc.uid;
  }
};